export default "__VITE_ASSET__7nuLqk6T__"